const JWT_TOKEN_KEY = 'API-JWT-TOKEN';

export class JwtTokenService {
  /**
   * Get JWT token from sessionStorage
   */
  static getToken(): string | null {
    return sessionStorage.getItem(JWT_TOKEN_KEY);
  }

  /**
   * Save JWT token to sessionStorage
   */
  static setToken(token: string): void {
    sessionStorage.setItem(JWT_TOKEN_KEY, token);
  }

  /**
   * Remove JWT token from sessionStorage
   */
  static removeToken(): void {
    sessionStorage.removeItem(JWT_TOKEN_KEY);
  }

  /**
   * Check if JWT token exists and has a value
   */
  static hasToken(): boolean {
    const token = this.getToken();
    return token !== null && token.trim() !== '';
  }
}